import type { I18nLocale } from "@/modules/i18n/types"
import type { FunctionComponent } from "react"

import classNames from "classnames"

import { Badge } from "@jobteaser/spark/components/Badge"
import { ChevronRight } from "@jobteaser/spark/components/Icons/ChevronRight"
import { Wand } from "@jobteaser/spark/components/Icons/Wand"
import { Text } from "@jobteaser/spark/components/Text"

import { PAGE_PATH } from "@/modules/aiCoverLetter/constants/constants"

import styles from "./Push.module.css"
import aiStyles from "@/modules/aiCoverLetter/components/AI.module.css"

type PushProps = {
  badgeLabel: string
  locale: I18nLocale
  text: string
}

export const Push: FunctionComponent<PushProps> = ({ locale, badgeLabel, text }) => {
  return (
    <a href={`/${locale}/${PAGE_PATH}`} className={styles.main}>
      <div className={styles.content}>
        <Badge icon={Wand} className={classNames(aiStyles.badge, styles.badge)}>
          {badgeLabel}
        </Badge>
        <Text variant="body1">{text}</Text>
      </div>
      <ChevronRight size={20} className={styles.icon} />
    </a>
  )
}
